/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPUTE_DISPLAY_OBJ =
  'GET_CURRENT_DISPUTE_DISPLAY_OBJ';
export const GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ =
  'GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ';
export const GET_DISPUTED_CLAIMS_DETAIL_OBJ = 'GET_DISPUTED_CLAIMS_DETAIL_OBJ';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM = 'GET_REBATE_PROGRAM';
export const GET_QUARTER_VALUE = 'GET_QUARTER_VALUE';
export const GET_ERROR_MSG_PERFORM_DISPUTE_RESOL =
  'GET_ERROR_MSG_PERFORM_DISPUTE_RESOL';
export const GET_MANUFACTURER_GRID_DATA = 'GET_MANUFACTURER_GRID_DATA';
export const GET_DISPLAY_CURRENT_DIPUTES_HEADER_AND_GRID =
  'GET_DISPLAY_CURRENT_DIPUTES_HEADER_AND_GRID';
export const SET_DISPLAY_CURRENT_DISPUTES = 'SET_DISPLAY_CURRENT_DISPUTES';
export const SET_DISPUTED_CLAIMS_DETAIL = 'SET_DISPUTED_CLAIMS_DETAIL';
export const SET_NDC_ACTIVITY_HISTORY = 'SET_NDC_ACTIVITY_HISTORY';
export const SET_PROVIDER_SUMMARY_HEADER_AND_GRID =
  'SET_PROVIDER_SUMMARY_HEADER_AND_GRID';
export const SET_PROVIDER_SUMMARY_REQ_HEADER =
  'SET_PROVIDER_SUMMARY_REQ_HEADER';
export const SET_NDC_HISTORY_REQ_HEADER = 'SET_NDC_HISTORY_REQ_HEADER';
export const SET_CLAIMS_DETAIL_REQ_HEADER = 'SET_CLAIMS_DETAIL_REQ_HEADER';
export const GET_STRENGTH_DESCR = 'GET_STRENGTH_DESCR ';
export const UPDATE_PROVIDER_SUMMARY_SAVE = 'UPDATE_PROVIDER_SUMMARY_SAVE';
export const PROVIDER_SUMMARY_GRID_LIST = 'PROVIDER_SUMMARY_GRID_LIST';
export const FULLSCREEN_SUMM_PRO_GRID = 'FULLSCREEN_SUMM_PRO_GRID';
export const FULLSCREEN_NDC_HISTORY_GRID = 'FULLSCREEN_NDC_HISTORY_GRID';
export const PROVIDER_SUMM_TAB_DATA = 'PROVIDER_SUMM_TAB_DATA';
export const FULLSCREEN_CLAIM_DETAIL_GRID = 'FULLSCREEN_CLAIM_DETAIL_GRID';
export const FULLSCREEN_REQUEST_MFG_GRID = 'FULLSCREEN_REQUEST_MFG_GRID';
export const FULLSCREEN_CURRENT_DISPUTES_GRID =
  'FULLSCREEN_CURRENT_DISPUTES_GRID';
export const SAVE_CANCEL_CLAIM_DETAIL = 'SAVE_CANCEL_CLAIM_DETAIL';
export const GET_PROVIDER_SUMMARY_GRID = 'GET_PROVIDER_SUMMARY_GRID';
export const GET_PROVIDER_SUMMARY_GRID_OBJ = 'GET_PROVIDER_SUMMARY_GRID_OBJ';
export const SELECTED_ROW_IN_MFG_GRID = 'SELECTED_ROW_IN_MFG_GRID';
export const DISPUTED_CLAIMS_DETAILS_SAVE = 'DISPUTED_CLAIMS_DETAILS_SAVE';
export const DISPUTED_CLAIMS_DETAILS_ERROR = 'DISPUTED_CLAIMS_DETAILS_ERROR';
export const DISPUTE_CURRENT_DISPUTE_ERROR = 'DISPUTE_CURRENT_DISPUTE_ERROR';
export const GET_INVOICE_DETAIL = 'GET_INVOICE_DETAIL';
export const SUM_OF_COUNT = 'SUM_OF_COUNT'
